import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function Link(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    fillRule: "evenodd",
    clipPath: "url(#prefix__clip0_1947_12)",
    clipRule: "evenodd"
  }, React.createElement(Path, {
    d: "M12.385 11.162a3.785 3.785 0 00-5.352-.07L5.269 12.81a4.193 4.193 0 105.852 6.008l.735-.717a1 1 0 111.396 1.433l-.736.716a6.193 6.193 0 01-8.643-8.873L5.637 9.66a5.785 5.785 0 018.18.108l.286.292a1 1 0 01-1.433 1.396l-.285-.293z"
  }), React.createElement(Path, {
    d: "M11.52 3.761a6.176 6.176 0 118.619 8.849l-1.797 1.75a5.803 5.803 0 01-8.205-.108l-.26-.268a1 1 0 111.432-1.395l.26.267a3.803 3.803 0 005.378.071l1.796-1.75a4.176 4.176 0 10-5.827-5.983l-.765.745a1 1 0 11-1.395-1.433l.764-.745z"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_1947_12"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default Link;